import img from '../../assets/lily-chan.jpg';

const Lily = {
  name: 'Lily Chan',
  bio: 'Lily Chan is a software engineer on the Web App Team. She believes that taking care of plants help people care about themselves and their surroundings.',
  url: 'lily',
  img,
};

export default Lily;
